/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Category_DescriptionInputs */

const en_directory_taxonomy_index_category_description = /** @type {(inputs: Directory_Taxonomy_Index_Category_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move from broad categories to focused sub-categories, then compare the tools published in each one.`)
};

const zh_directory_taxonomy_index_category_description = /** @type {(inputs: Directory_Taxonomy_Index_Category_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从宽泛的分类进入具体的子分类，再比较每个子分类中已经发布的工具。`)
};

/**
* | output |
* | --- |
* | "Move from broad categories to focused sub-categories, then compare the tools published in each one." |
*
* @param {Directory_Taxonomy_Index_Category_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_category_description = /** @type {((inputs?: Directory_Taxonomy_Index_Category_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Category_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_category_description(inputs)
	return zh_directory_taxonomy_index_category_description(inputs)
});
export { directory_taxonomy_index_category_description as "directory.taxonomy_index.category.description" }